import { all } from 'redux-saga/effects';
import { watchSecurityPayment } from './components/securityPayment/saga/watchhers';
import { watchCheckOnExistingEmail } from './components/whatsYourEmail/saga/watchhers';
import { watchPaymentPlan } from './components/paymentPlan/saga/watchhers';
import { watchPersonalSummary } from './components/quizResults/saga/watchhers';

export default function* rootSaga() {
  yield all([watchSecurityPayment(), watchCheckOnExistingEmail(), watchPaymentPlan(), watchPersonalSummary()]);
}
